import pmsConstants from "../pmsConstants";
import PmsUrlConfig from "../urlConfig";
import Axios from 'axios';

function formatPhoneNumber(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, '');

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early

    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
    )}-${phoneNumber.slice(6, 10)}`;
}

/* eslint-disable */
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
const eINRegex = /^\d{2}\-?\d{7}$/;

const validateUsername = async (username) => {
    var validateUsernameUrl = PmsUrlConfig.BOS_GENERATE_USERNAME + username.toLowerCase()

    Axios.get(validateUsernameUrl)
        .then(response => response.data)
        .then(validUsername => {
            if (username === validUsername) {
                return true
            } else {
                return false
            }
        }).catch((error) => {
        console.log("-----------------", error)
        return false;
    })
}

const populateServiceTypes = async (dispatch, token) => {
    setAuthToken(token);
    var getServiceTypesUrl = PmsUrlConfig.BOS_GET_SERVICE_TYPES_URL;

    Axios.get(getServiceTypesUrl)
        .then(response => response.data)
        .then(serviceTypes => {
            console.log(serviceTypes)
            var serTypes = [];
            var sType = {"value": "", "label": ""};
            serviceTypes.map((item) => (
                sType['value'] = item.service_code,
                    sType['label'] = item.service_name,
                    serTypes.push(sType),
                    sType = {"value": "", "label": ""}
            ));
            dispatch({
                type: 'populateServiceTypes',
                payload: serTypes,
            });
        }).catch((error) => {
        console.log("-----------------", error)
        return null;
    })
}

const isPatientUser = (loggedInUser) => {
    if (loggedInUser.user_type === pmsConstants.USER_TYPE_PATIENT)
        return true;
    else
        return false;
}

const isPracticeUser = (loggedInUser) => {
    if (loggedInUser.user_type === pmsConstants.USER_TYPE_PRACTICE_STRING)
        return true;
    else
        return false;
}

const isStaffUser = (loggedInUser) => {
    if (loggedInUser.user_type === pmsConstants.USER_TYPE_STAFF_STRING)
        return true;
    else
        return false;
}

const handleServiceTypeChange = (selectedTypes, setFieldValue, dispatch) => {
    console.log(selectedTypes);
    var serTypes = [];
    selectedTypes.map((item) => (
        serTypes.push(item.value)
    ));
    dispatch({
        type: 'serviceTypeChange',
        payload: selectedTypes // Store full objects, not just codes
    })
    if (selectedTypes.length > 0) {
        setFieldValue('pmsServiceType', selectedTypes);
    } else {
        setFieldValue('pmsServiceType', []);
    }
};
const getPractice = async (practice_id, dispatch, token) => {
    console.log('=== getPractice CALLED ===');
    console.log('Practice ID:', practice_id);
    console.log('Token exists:', !!token);
    console.log('Current time:', new Date().toISOString());
    console.log('Stack trace:', new Error().stack);
    console.log('=== END getPractice DEBUG ===');
    
    setAuthToken(token);
    var getPracticeUrl = PmsUrlConfig.BOS_GET_PRACTICE_UPDATES_URL + practice_id

    console.log('Making GET request to:', getPracticeUrl);
    Axios.get(getPracticeUrl)
        .then(response => response.data)
        .then(practiceData => {
            dispatch({
                type: 'updatePracticeDetails',
                payload: practiceData
            });

        })
        .catch((error) => {
            console.log(error);
            console.log(error.response.data.error_code.description);
        })
}

const setAuthToken = token => {
    if (token) {
        Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else
        delete Axios.defaults.headers.common["Authorization"];
}

// Global axios interceptor for JWT token expiration handling
Axios.interceptors.response.use(
    response => response,
    error => {
        // Handle JWT token expiration
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.log('JWT token expired or invalid, clearing localStorage');
            
            // Show alert with error details before redirect
            const errorMessage = `Authentication Error (${error.response.status}):\n\n` +
                `URL: ${error.config?.url || 'Unknown'}\n` +
                `Method: ${error.config?.method?.toUpperCase() || 'Unknown'}\n` +
                `Status: ${error.response.status}\n` +
                `Message: ${error.response?.data?.message || error.message || 'Unknown error'}\n\n` +
                `This will redirect to login page.`;
            
            alert(errorMessage);
            
            localStorage.clear();
            // Redirect to login page
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);
const logout = (dispatch) => {
    if (dispatch) {
        // Clear all localStorage data on logout
        localStorage.clear();
        console.log('localStorage cleared on logout');
        
        dispatch({type: 'logout'});
        dispatch({type: 'logoutPractice'});
        dispatch({type: 'clearMessage'});
    }
};

const getServiceTypeLabel = (serviceCode, serviceTypes) => {
    var serviceType = serviceTypes.filter(item => item.value === serviceCode);
    if (serviceType && serviceType.length === 1) {
        return serviceType[0].label;
    }
    return "";
}

const getServiceTypesById = (serviceTypes, ids) => {
    console.log(`ids: ${JSON.stringify(ids)}`)
    console.log(`serviceTypes: ${JSON.stringify(serviceTypes)}`)
    var result = [];
    serviceTypes.forEach((serviceType) => {
       if (ids.includes(serviceType.value)){
           result.push({"service_code": serviceType.value, "service_name": serviceType.label})
       }
    })
    return result;
}

const calculateAge = (dob) => {
    console.log(dob);
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);

    return age_dt.getUTCFullYear() - 1970;
}

function sixDigitCode(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const vCode = value.replace(/[^\d]/g, '');
    if (vCode.length < 6)
        return vCode
    else
        return vCode.slice(0, 6)
}

export {
    formatPhoneNumber,
    emailRegex,
    eINRegex,
    validateUsername,
    isPatientUser,
    isPracticeUser,
    isStaffUser,
    populateServiceTypes,
    getPractice,
    handleServiceTypeChange,
    setAuthToken,
    logout,
    getServiceTypeLabel,
    getServiceTypesById,
    calculateAge,
    sixDigitCode
}